import { Alert } from 'api/alerts/alerts.types';
import parse, {
  domToReact,
  Element,
  HTMLReactParserOptions,
} from 'html-react-parser';
import { Link } from 'react-router-dom';

const parserOptions: HTMLReactParserOptions = {
  replace: (domNode) => {
    if (domNode instanceof Element && domNode.attribs) {
      if (domNode.type === 'tag' && domNode.attribs.href) {
        return (
          <Link to={domNode.attribs.href.replace('#', '')}>
            {domToReact(domNode.children, parserOptions)}
          </Link>
        );
      }
    }
  },
};

interface Props {
  alert: Alert;
}

const parseHref = (txt: string) => {
  const parser = new DOMParser();
  const htmlDoc = parser.parseFromString(txt, 'text/html');
  const anchorTags = htmlDoc.getElementsByTagName('a');

  return anchorTags.length
    ? anchorTags[0].getAttribute('href')?.replace('#', '')
    : null;
};

export const PollAlertToast = ({ alert }: Props) => {
  const parsedHref = parseHref(alert.message);

  return parsedHref ? (
    <Link to={parsedHref}>{parse(alert.message, parserOptions)}</Link>
  ) : (
    <div>{parse(alert.message, parserOptions)}</div>
  );
};
